import { render, staticRenderFns } from "./DetailPreview.vue?vue&type=template&id=638e0d88&scoped=true&"
import script from "./DetailPreview.vue?vue&type=script&lang=js&"
export * from "./DetailPreview.vue?vue&type=script&lang=js&"
import style0 from "./DetailPreview.vue?vue&type=style&index=0&id=638e0d88&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638e0d88",
  null
  
)

export default component.exports